import { SortableStatsTable, type StatsColumn } from "../components/SortableStatsTable";
import { Notice } from "../components/Notice";
import { QueryErrorState, TabHeading, TabSkeleton } from "../components/tab-states";
import { useStats } from "../data/queries";

const meceColumns: StatsColumn[] = [
  { key: "domino", label: "Domino", strong: true },
  { key: "keywords", label: "Keywords", numeric: true },
  { key: "search_volume", label: "Search vol", numeric: true, format: "thousands" },
  { key: "acos", label: "ACOS", numeric: true, format: "decimal2" },
  { key: "profit_yield", label: "Profit yield", numeric: true, variant: "band-ratio", format: "decimal2" },
  { key: "markets", label: "Markets" },
  { key: "action", label: "Action" },
];

const tgColumns: StatsColumn[] = [
  { key: "target_group", label: "Target group", strong: true },
  { key: "asin", label: "ASIN", variant: "mono" },
  { key: "status", label: "Status" },
  { key: "markets", label: "Markets" },
  { key: "keywords", label: "# Kw", numeric: true },
  { key: "campaigns", label: "Campaigns", numeric: true },
  { key: "acos", label: "ACOS", numeric: true, format: "decimal2" },
  { key: "search_volume", label: "SV", numeric: true, format: "thousands" },
  { key: "spend", label: "Spend", numeric: true, format: "decimal2" },
  { key: "profit_yield", label: "Profit yield", numeric: true, variant: "band-ratio", format: "decimal2" },
  { key: "consistency", label: "Consistency" },
];

/** Coverage and target-group summary from the control read model. */
export function StatsTab() {
  const stats = useStats();

  return (
    <div className="flex flex-col gap-4">
      <TabHeading
        title="Stats"
        description="MECE Coverage and TG Summary from the machine control read model. The per-keyword action log lives on the Keyword Status tab."
      />
      {stats.isPending ? (
        <TabSkeleton />
      ) : stats.isError ? (
        <QueryErrorState title="Stats unavailable" onRetry={() => stats.refetch()} />
      ) : !stats.data ? (
        // Stated as not-built-yet rather than shown as zeroes: a table of zeroes
        // is indistinguishable from a system that measured nothing.
        <Notice title="Coming with the C9a stats extension">
          Stats are not wired up yet. No zeros or mock data are shown.
        </Notice>
      ) : (
        <>
          <SortableStatsTable
            title="MECE Coverage"
            rows={stats.data.mece_coverage}
            columns={meceColumns}
            filters={[{ key: "domino", label: "Domino" }]}
          />
          <SortableStatsTable
            title="TG Summary"
            rows={stats.data.tg_summary}
            columns={tgColumns}
            filters={[
              { key: "status", label: "Status" },
              { key: "markets", label: "Markets" },
            ]}
          />
        </>
      )}
    </div>
  );
}
